import { NextRouter } from 'next/router';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

export const createRouterReplace = (router: NextRouter | AppRouterInstance) => {
  return (url: string) => {
    router.replace(url);
    return Promise.resolve(true);
  };
};
